<i18n locale="en">
{
  "actions": {
    "order": "Order online"
  }
}
</i18n>

<template>
  <PreviewSheet
    :style="{ backgroundColor }"
    class="website-builder-preview-navbar flex justify-between"
    border="primary"
    radius="0"
  >
    <div class="flex-row align-center">
      <PreviewLogo logo-size="base" />
    </div>
    <div class="flex-row align-center justify-end gap-6">
      <div class="flex-row align-center">
        <NavbarMenuLinkPreview
          :active-page="activePage"
          :nav-links="navItems"
        />
      </div>
      <PreviewButtonLegacy size="xsmall">
        <PreviewTypographyLegacy
          :text="t('actions.order')"
          color="white"
          variant="buttonSmall"
        />
      </PreviewButtonLegacy>
    </div>
  </PreviewSheet>
</template>

<script>
import { useI18n } from 'vue-i18n'
import { mapGetters } from 'vuex'

import { useActiveBrand } from '@/core/store'
import PreviewButtonLegacy from '@/lib/builder/public/preview/legacy/PreviewButtonLegacy.vue'
import PreviewTypographyLegacy from '@/lib/builder/public/preview/legacy/PreviewTypographyLegacy.vue'
import { useMergedTheme } from '@/lib/builder/public/preview/mixins/useMergedTheme'
import PreviewLogo from '@/lib/builder/public/preview/PreviewLogo.vue'
import PreviewSheet from '@/lib/builder/public/preview/PreviewSheet.vue'

import NavbarMenuLinkPreview from './NavbarMenuLinkPreview'

export default {
  name: 'WebsiteBuilderPreviewNavbar',
  components: {
    NavbarMenuLinkPreview,
    PreviewButtonLegacy,
    PreviewLogo,
    PreviewSheet,
    PreviewTypographyLegacy,
  },
  mixins: [useMergedTheme],
  props: {
    /**
     * Active page to show
     */
    activePage: { type: String, default: undefined },

    /**
     * Show in spacer mode
     */
    spacer: { type: Boolean, default: false },
  },
  setup() {
    const { t } = useI18n()
    const { locations: activeBrandLocations } = useActiveBrand()

    return { activeBrandLocations, t }
  },
  computed: {
    ...mapGetters({
      currentResource: 'websiteBuilder/currentResource',
    }),
    backgroundColor() {
      const { mergedTheme } = this

      const themeBg = mergedTheme?.colors?.background?.primary

      return `${themeBg}E6`
    },
    navItems() {
      const { currentResource } = this

      // Filter out home pages since the brand logo serves as the home button
      // Also filter out locations and loyalty action items (https://linear.app/owner/issue/GUE-440/remove-locations-nav-item-on-olympus-and-hermes)
      return (currentResource?.nav ?? []).filter((item) => {
        // Filter out locations and loyalty action items
        if (
          item.type === 'action' &&
          (item.params.action === 'locations' ||
            item.params.action === 'loyalty')
        ) {
          return false
        }
        // Filter out home page items - use the path structure from the nav item
        return !(
          item.type === 'page' && item.params?.path?.params?.page === 'index'
        )
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.website-builder-preview-navbar {
  padding: 16px 96px;
}
</style>
